/**
 * Device 그룹 브릿지 목데이터
 */

import type { DeviceGroup } from './types'

// Device group mock responses
export const deviceMocks: Record<keyof DeviceGroup, any> = {
  getAdvertisingId: { advertisingId: 'mock-advertising-id' },
  isLimitAdTrackingEnabled: { isLat: '0' },
  getDeviceInfo: {
    osVer: '16',
    packageName: 'co.adison.offerwall.sample',
    appVer: '1.0.0',
    sdkVer: '5.0.0-alpha03',
    appId: 'f7Pq9yXSooZPHRLv9M5rXQhG',
    deviceModel: 'sdk_gphone64_arm64',
    deviceBrand: 'Google',
    firstLaunchTime: '2025-11-10T18:19:32+09:00',
    firstInstallTime: '2025-11-10T15:12:35+09:00',
    lastUpdateTime: '2025-11-10T18:15:55+09:00',
    trackingId: 'acd855bc-516c-42c9-a3c6-77044ab3ec5d',
    width: 1080,
    height: 2400
  },
  getNetworkState: { networkState: 'wifi' }
}
